import React from 'react'
import { Alert } from 'react-bootstrap'

import { ShiftSelectStep } from './ShiftSelectStep'
import { SpotDecisionStep } from './SpotDecisionStep'
import { CancelStep } from './types'

// Which body the dialog shows: a load error, the loading row, step 1, or step 2.
// Extracted so the container's render is a flat Modal + one component instead of a
// four-way nested ternary.
export const ModalBody = ({
  loadError,
  loading,
  step,
  selectStepProps,
  spotDecisionStepProps,
}: {
  loadError?: string
  loading: boolean
  step: CancelStep
  selectStepProps: React.ComponentProps<typeof ShiftSelectStep>
  spotDecisionStepProps: React.ComponentProps<typeof SpotDecisionStep>
}) => {
  if (loadError) {
    return <Alert bsStyle="danger">{loadError}</Alert>
  }
  if (loading) {
    return <div className="loading-row">Loading this worker's bookings…</div>
  }
  if (step === 'select') {
    return <ShiftSelectStep {...selectStepProps} />
  }

  return <SpotDecisionStep {...spotDecisionStepProps} />
}
